import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  hu: {
    // Navigation
    nav: {
      home: 'Kezdőlap',
      course: 'Online Kurzus',
      workWithMe: 'Együttműködés',
      favorites: 'Kedvencek',
      subscribe: 'Feliratkozás',
    },
    // Hero
    hero: {
      greeting: 'Szia,',
      name: 'Hamikus Renata',
      greetingAfter: 'vagyok',
      tagline: 'Wellness • Motiváció • Szépség',
      description: 'Inspiráció a mindennapokra, kívül és belül.',
      followMe: 'Kövess be',
    },
    // Social Stats
    social: {
      title: 'Közösségem',
      followers: 'követő',
      tiktok: 'TikTok',
      instagram: 'Instagram',
      youtube: 'YouTube',
    },
    // Course Section
    course: {
      title: 'Pénzkeresés Online',
      subtitle: 'A Te Utad a Pénzügyi Szabadsághoz',
      description: 'Tanuld meg, hogyan kereshetsz pénzt online, akár nulláról is. Ez a kurzus mindenkinek szól, aki szabadságra vágyik.',
      whoIsItFor: 'Kiknek szól?',
      whoIsItForText: 'Mindenkinek, aki szeretne pénzt keresni az internetről - függetlenül a korától, tapasztalatától vagy végzettségétől.',
      whatProblem: 'Milyen problémát old meg?',
      whatProblemText: 'Megtanít step-by-step, hogyan építs fel egy online bevételi forrást, hogy megszabadulj a hagyományos munkaidő korlátaitól.',
      cta: 'Kezdd El Most',
      learnMore: 'Tudj Meg Többet',
    },
    // Work With Me
    workWithMe: {
      title: 'Együttműködés Márkákkal',
      subtitle: 'Építsünk együtt valamit nagyszerűt',
      description: 'Nyitott vagyok kreatív együttműködésekre wellness, szépség és életmód márkákkal.',
      cta: 'Jelentkezz Együttműködésre',
      formSteps: {
        brand: 'Milyen a márkád neve és weboldala/social linkje?',
        contact: 'Hogyan érhetünk el téged?',
        platform: 'Melyik platformon szeretnéd, hogy promótáljam a terméked?',
        videoCount: 'Hány videót szeretnél?',
        videoLength: 'Milyen hosszú videókat szeretnél?',
        extraAds: 'Szeretnél extra hirdetéseket a videóban?',
        postingDate: 'Mikor szeretnéd, hogy posztoljam a videót?',
        brief: 'Van kész kampány briefed?',
      },
      submit: 'Küldés',
      success: 'Köszönöm! Hamarosan felveszem veled a kapcsolatot.',
      next: 'Tovább',
      back: 'Vissza',
      brandName: 'Márka neve',
      brandLink: 'Weboldal vagy Social link',
      contactName: 'Neved',
      contactEmail: 'Email címed',
      contactPhone: 'Telefonszámod',
    },
    // Favorites
    favorites: {
      title: 'Kedvenc Termékeim',
      subtitle: 'A legjobb termékek, amiket használok és szeretek',
      description: 'Összeállítottam neked a kedvenc wellness és szépségápolási termékeimet.',
      cta: 'Nézd Meg a Kedvenceimet',
    },
    // Free Value / Subscribe
    subscribe: {
      title: 'Csatlakozz a Közösségemhez',
      subtitle: 'Exkluzív tartalmak és ingyenes ajándékok',
      description: 'Iratkozz fel és kapj exkluzív tippeket, ingyenes PDF-eket és első kézből értesülj az újdonságokról!',
      placeholder: 'Email címed',
      cta: 'Feliratkozom',
      success: 'Köszönöm a feliratkozást! 💛',
      error: 'Ez az email már fel van iratkozva.',
    },
    // Footer
    footer: {
      copyright: '© 2026 Renata Hamikus. Minden jog fenntartva.',
      madeWith: 'Készült szeretettel',
    },
    // Form Options
    options: {
      platforms: ['TikTok', 'Instagram', 'YouTube'],
      videoCounts: ['1 videó', '2-3 videó', '4-5 videó', '5+ videó'],
      videoLengths: ['15-30 másodperc', '30-60 másodperc', '1-3 perc', '3+ perc'],
      extraAds: ['Igen', 'Nem', 'Talán - beszéljük meg'],
      brief: ['Igen, van briefem', 'Nem, segítségre van szükségem', 'Részben kész'],
    },
  },
  en: {
    // Navigation
    nav: {
      home: 'Home',
      course: 'Online Course',
      workWithMe: 'Work With Me',
      favorites: 'Favorites',
      subscribe: 'Subscribe',
    },
    // Hero
    hero: {
      greeting: "Hi, I'm",
      name: 'Renata Hamikus',
      greetingAfter: '',
      tagline: 'Wellness • Motivation • Beauty',
      description: 'Daily inspiration, inside and out.',
      followMe: 'Follow Me',
    },
    // Social Stats
    social: {
      title: 'My Community',
      followers: 'followers',
      tiktok: 'TikTok',
      instagram: 'Instagram',
      youtube: 'YouTube',
    },
    // Course Section
    course: {
      title: 'Make Money Online',
      subtitle: 'Your Path to Financial Freedom',
      description: 'Learn how to make money online, even from scratch. This course is for everyone who craves freedom.',
      whoIsItFor: 'Who is it for?',
      whoIsItForText: 'Anyone who wants to earn money online - regardless of age, experience, or education.',
      whatProblem: 'What problem does it solve?',
      whatProblemText: 'It teaches you step-by-step how to build an online income source, freeing you from traditional work hour constraints.',
      cta: 'Start Now',
      learnMore: 'Learn More',
    },
    // Work With Me
    workWithMe: {
      title: 'Brand Collaborations',
      subtitle: "Let's build something great together",
      description: "I'm open to creative collaborations with wellness, beauty, and lifestyle brands.",
      cta: 'Apply for Collaboration',
      formSteps: {
        brand: "What is your brand name and website/social link?",
        contact: 'How can we reach you?',
        platform: 'On which platform would you like me to promote your product?',
        videoCount: 'How many videos would you like?',
        videoLength: 'What video length do you prefer?',
        extraAds: 'Would you like to add extra ads to the video?',
        postingDate: 'When would you like me to post the video?',
        brief: 'Do you have a ready campaign brief?',
      },
      submit: 'Submit',
      success: "Thank you! I'll get back to you soon.",
      next: 'Next',
      back: 'Back',
      brandName: 'Brand Name',
      brandLink: 'Website or Social Link',
      contactName: 'Your Name',
      contactEmail: 'Your Email',
      contactPhone: 'Your Phone Number',
    },
    // Favorites
    favorites: {
      title: 'My Favorite Products',
      subtitle: 'The best products I use and love',
      description: "I've curated my favorite wellness and beauty products for you.",
      cta: 'View My Favorites',
    },
    // Free Value / Subscribe
    subscribe: {
      title: 'Join My Community',
      subtitle: 'Exclusive content and free goodies',
      description: 'Subscribe and get exclusive tips, free PDFs, and be the first to know about updates!',
      placeholder: 'Your email address',
      cta: 'Subscribe',
      success: 'Thanks for subscribing! 💛',
      error: 'This email is already subscribed.',
    },
    // Footer
    footer: {
      copyright: '© 2026 Renata Hamikus. All rights reserved.',
      madeWith: 'Made with love',
    },
    // Form Options
    options: {
      platforms: ['TikTok', 'Instagram', 'YouTube'],
      videoCounts: ['1 video', '2-3 videos', '4-5 videos', '5+ videos'],
      videoLengths: ['15-30 seconds', '30-60 seconds', '1-3 minutes', '3+ minutes'],
      extraAds: ['Yes', 'No', 'Maybe - let\'s discuss'],
      brief: ['Yes, I have a brief', 'No, I need help', 'Partially ready'],
    },
  },
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('hu');
  
  useEffect(() => {
    // Check browser language preference
    const browserLang = navigator.language.substring(0, 2);
    if (browserLang === 'hu' || browserLang === 'en') {
      setLanguage(browserLang);
    }
    
    // Check localStorage
    const savedLang = localStorage.getItem('language');
    if (savedLang) {
      setLanguage(savedLang);
    }
  }, []);
  
  const toggleLanguage = () => {
    const newLang = language === 'hu' ? 'en' : 'hu';
    setLanguage(newLang);
    localStorage.setItem('language', newLang);
  };
  
  const setLang = (lang) => {
    setLanguage(lang);
    localStorage.setItem('language', lang);
  };
  
  const t = translations[language];
  
  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
